<template>
  <div class="pravo-sirsi__teams">
    <div v-for="team in sourceData" :key="team.id">
      <div class="pravo-sirsi__teams__team">
        <!--<div class="pravo-sirsi__teams__team__name">Team n.{{ team.id }}</div>-->
        <div class="pravo-sirsi__teams__team__box">
          <div class="pravo-sirsi__teams__team__box__row">
            <span class="pravo-sirsi__teams__team__box__row__name">{{
              team.name
            }}</span>
            <button
              v-if="lobbyMyTeamId === team.id"
              class="pravo-sirsi__teams__team__box__row__leave button"
              @click="leaveTeam"
            >
              Leave team
            </button>
            <button
              v-else
              class="pravo-sirsi__teams__team__box__row__join button"
              @click="joinTeam(team.id)"
            >
              Join team
            </button>
          </div>
          <div class="pravo-sirsi__teams__team__box__users">
            <div v-for="player in team.players" :key="player.id">
              <div class="pravo-sirsi__teams__team__box__users__user">
                <div class="pravo-sirsi__teams__team__box__users__user__img">
                  <div
                    class="pravo-sirsi__teams__team__box__users__user__img__img"
                  ></div>
                </div>
                <div class="pravo-sirsi__teams__team__box__users__user__name">
                  {{ player.username }}
                </div>
              </div>
            </div>
          </div>
          <div class="pravo-sirsi__teams__team__box__bottom"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ModalJs from "@/components/general/ModalJs.js";
import sortingLogicMixin from "@/components/game/table/sortingLogicMixin.js";

export default {
  name: "Teams",
  mixins: [ModalJs, sortingLogicMixin],
  data() {
    return {
      currentSortRow: "round",
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters({
      sourceData: "lobbyTeams",
      lobbyMyTeamId: "lobbyMyTeamId",
    }),
  },
  methods: {
    async joinTeam(id) {
      await this.$store.dispatch("joinTeam", id);
    },
    async leaveTeam() {
      await this.$store.dispatch("leaveTeam");
    },
  },
};
</script>
